import styled from 'styled-components';
import { SearchIcon, PlayCircleIcon } from '../../atoms/Icons';
import { MushiAndQuizLogo, CreateQuizFullLogo, PlayQuizFullLogo, SearchQuizLogo,Mushi2Logo } from '../../atoms/Logo';
import Divider from '../../atoms/Divider';
import FloatingActionButton from '../../atoms/FloatingActionButton';
import IconButton from '../../atoms/IconButton';
import DemoContent from '../DemoContent';
import patternImg from '../../images/chalkboard-green-pattern-01.jpg';
import Signup from '../../molecules/Signup';
import { OnPrimary, SurfaceColor } from '../../Colors';


const defaultStyle = {
	Wrapper: styled.div`
        padding-left : 1rem;
        padding-right : 1rem;
        padding-bottom : 2rem;
    `,
	HeadlineWrapper: styled.div`
        padding : 2rem;
        text-align : center;
    `,
	Content : styled.div`
        background-image : ${`url(${patternImg})`};
        border-radius : 5px;
        padding : 2rem;
        & > h4{
            color : ${OnPrimary};
            padding-bottom : 1rem;
            text-align : center;
        }
    `,
	Headline: styled.div`
    `,
	SubHeadline : styled.div`
        display : flex;
        justify-content : center;
        & > div {
            width : 500px;
            & > span {
                display : inline-block;
            }
        }
    `,
	HeadlineImages: styled.div`
    `,
	SearchIcon: styled(SearchIcon)`
        font-size : 2rem;
    `,
	h2: styled.h2`
    `,
	h3: styled.h3`
    `,
	h4: styled.h4`
    `,
	p: styled.p`
    `,
	FeaturesOverview: styled.div`
        display : flex;
        justify-content: center;
        margin-top : 2rem;
    `,
	Features: styled.div`
        margin-top : 4rem;
        & > #features {
            padding : 1rem;
            display : grid;
            grid-template-columns: 1fr 1fr 1fr;
            align-items : flex-start;
        }
    `,
	Feature: styled.div`
        display : flex;
        flex-direction : column;
        align-items : center;
        justify-content : center;
    `,
	IconButton,
	PlayCircleIcon,
	Mushi2Logo : styled(Mushi2Logo)`
        width : 50px;
        height : 50px;
        margin-left : 1rem;
    `,
	MushiAndQuizLogo: styled(MushiAndQuizLogo).attrs({
		width: '50%',
		height: '50%'
	})`
        margin-top : 1rem;
        margin-bottom : 1rem;
    `,
	CreateQuizFullLogo: styled(CreateQuizFullLogo).attrs({
		width: '75%',
		height: 'auto'
	})`
        padding : 3px;
    `,
	Divider,
	FeatureText: styled.div`
        padding : 2rem;
        text-align : center;
    `,
	ImageWrapper : styled.div`
        background-color : ${SurfaceColor};
        border-radius : 50%;
        width : 200px;
        height : 200px;
        display : flex;
        align-items : center;
        justify-content : center;
    `,
	PlayQuizFullLogo: styled(PlayQuizFullLogo).attrs({
		width: '70%',
		height: 'auto'
	})`
        padding : 3px;
    `,
	SearchQuizLogo: styled(SearchQuizLogo).attrs({
		width: '75%',
		height: 'auto'
	})`
        padding : 3px;
    `,
	StartButtonWrapper : styled.div`
        padding : 2rem;
        text-align : center;
    `,
	DemoContent : styled(DemoContent)`
    `,
	FloatingActionButton : styled(FloatingActionButton)`
        padding : 1rem;
        font-size : 2.5rem;
    `,
	Signup
};

const mobileStyle = {
	Wrapper: styled.div`
        padding-bottom : 2rem;
    `,
	HeadlineWrapper: styled.div`
        padding : 2rem;
        text-align : center;
`,
	SubHeadline : styled.div`
        & > span {
            display : inline-block;
        }
        margin-bottom : 2rem;
    `,
	Content : styled.div`
        background-image : ${`url(${patternImg})`};
        padding : 1rem 0;
        & > h4{
            color : ${OnPrimary};
            padding-bottom : 1rem;
            text-align : center;
            &>span{
                display : inline-block;
            }
        }
    `,
	ImageWrapper : styled.div`
        background-color : ${SurfaceColor};
        border-radius : 50%;
        width : 100px;
        height : 100px;
        display : flex;
        align-items : center;
        justify-content : center;
    `,
};

export default defaultStyle;
export {mobileStyle};